(async () => {

  if (!customElements.get('country-popup')) {

    const { Fancybox } = await import('@fancyapps/ui');
    const { default: Cookies } = await import('js-cookie');

    class CountryPopup extends HTMLElement {

      constructor() {
        super();

        // Scope
        const self = this;

        // Scope elements
        self.countryPopupWrapper = self.querySelector('[data-country-popup-wrapper]');
        self.buttonStay = self.countryPopupWrapper.querySelector('[data-country-popup-stay]');

        // set country popup cookie identifier
        self.countryPopupCookieIdentifier = "country_popup";

        // Default options
        self.defaultOptions = {
          currentCountryCode: '',
          locationApiUrl: 'https://extreme-ip-lookup.com/json',
          expiresInDays: 0,
          locationFieldName: 'countryCode',
          popupMessages: {}
        };

        self.dataOptions = {};

        // Get options from element data and combine with default options
        if (self?.dataset.options) {
          self.dataOptions = JSON.parse(self.dataset.options);
        }

        self.options = {
          ...self.defaultOptions,
          ...self.dataOptions
        };

        self.init();

        // Listen to extra events when in Shopify editor
        if (Shopify.designMode) {

          // Update the swiper when the section event is triggered
          window.addEventListener('shopify:section:load', (event) => {
            if (event.detail.sectionId == "country-popup") {
              Fancybox.close();
              self.init();
            }
          });
        }
      }

      /**
       * Init the country popup plugin
       * @returns void
       */
      init() {

        // Scope
        const self = this;

        // if country popup days is set to zero, remove cookie if exists
        if (parseInt(self.options.expiresInDays) == 0) {
          Cookies.remove(self.countryPopupCookieIdentifier);
        }

        // Get and scope country popup cookie
        self.countryPopupCookie = Cookies.get(self.countryPopupCookieIdentifier);
        if (typeof self.countryPopupCookie == 'undefined') {
          self.countryPopupCookie = 'true';
        }
        self.countryPopupCookie = (self.countryPopupCookie === 'true');

        // Render country popup if given
        if (!self.mayRenderCountryPopup()) {
          return false;
        }

        // get country location
        self.getLocation(function (countryCode) {

          // render the country popup
          self.renderCountryPopup(countryCode);
        });

        // button close popup
        self.buttonStay.addEventListener('click', (e) => {
          e.preventDefault();
          self.closeCountryPopup();
        });

      }

      /**
       * Check if the country popup may be rendered and that there is a message to show
       * @returns boolean
       */
      mayRenderCountryPopup() {

        // Scope
        const self = this;

        // guard: check if popup cookie is set
        if (!self.countryPopupCookie) {
          return false;
        }
        // guard: check if there are messages given
        if (self.options.popupMessages.length == 0) {
          return false;
        }

        return true;
      }

      /**
       * Get country location from cookie or GeoAPI
       * @returns string countryCode
       */
      getLocation(callback) {

        // Scope
        const self = this;

        // get country code from cookie
        self.countryCode = Cookies.get(self.countryPopupCookieIdentifier + '-country_code');

        // if country code is given, return the code
        if (self.countryCode) {
          return callback(self.countryCode);
        }

        // get country code from api, if done call the callback
        self.getCountryCodeFromAPI().then((countryCode) => {
          self.setCountryCode(countryCode);
          return callback(countryCode);
        });

        return self.countryCode;
      }

      /**
       * Get country code from API service
       * @returns promise
       */
      getCountryCodeFromAPI() {

        // scope
        const self = this;

        const defaultApiUrl = '//extreme-ip-lookup.com/json/';
        const countryCodeApi = self.options.locationApiUrl || defaultApiUrl;
        const countryCodeFieldnameIdentifier = self.options.locationFieldName || 'country_code';

        // guard: get country code api url from options or get country code field name
        if (countryCodeApi == '' || countryCodeFieldnameIdentifier == '') {
          return self;
        }

        // Get country code from api
        return fetch(countryCodeApi)
          .then(response => response.json())
          .then(data => {
            if (typeof data[countryCodeFieldnameIdentifier] != "undefined" && data[countryCodeFieldnameIdentifier] != '') {
              return data[countryCodeFieldnameIdentifier];
            }
          });
      }

      /**
       * Render the country popup
       * @return string countryCode
       */
      setCountryCode(countryCode) {

        // Scope
        const self = this;

        // guard: check country code is given
        if (typeof countryCode == "undefined" || countryCode == '') {
          return '';
        }

        // set the country code
        self.countryCode = countryCode;

        // create a cookie with the country code
        Cookies.set(self.countryPopupCookieIdentifier + '-country_code', countryCode, {
          expires: 1
        });

        return countryCode;
      }

      /**
       * Render the country popup
       * @returns void
       */
      renderCountryPopup(countryCode) {

        // Scope
        const self = this;
        self.countryCode = countryCode;

        // check country code is given
        if (self.countryCode == '' || self.options.currentCountryCode == '') {
          return;
        }
        // guard: if the given countryCode is the same as the shop country code then skip!
        if (self.countryCode == self.options.currentCountryCode) {
          return;
        }

        let countryData;
        // get the data by country code if available
        if (typeof self.options.popupMessages[self.countryCode] != 'undefined') {
          countryData = self.options.popupMessages[self.countryCode];

          // if country option does not exists shop ROW
        } else if (typeof self.options.popupMessages['ROW'] != 'undefined') {
          countryData = self.options.popupMessages['ROW'];

          // guard: no country data to render
        } else {
          return;
        }

        // populate the wrapper with the country data
        self.countryPopupWrapper.querySelector('[data-country-popup-title]').innerHTML = countryData.countryTitle;
        self.countryPopupWrapper.querySelector('[data-country-popup-name-title]').innerHTML = countryData.countryName;
        self.countryPopupWrapper.querySelector('[data-country-popup-text]').innerHTML = countryData.countryBody;
        self.countryPopupWrapper.querySelector('[data-country-popup-url]').href = countryData.countryUrl;
        self.countryPopupWrapper.querySelector('[data-country-popup-url]').title = countryData.countryButton;
        self.countryPopupWrapper.querySelector('[data-country-popup-label]').innerHTML = countryData.countryButton;
        self.countryPopupWrapper.querySelector('[data-country-popup-stay]').innerHTML = countryData.countryStay;
    

        // Open fancybox and set callback for destroy event
        Fancybox.show(
          [
            {
              src: self.countryPopupWrapper,
              type: "html",
            },
          ],
          {
            mainClass: 'fancybox--is-country-popup',
            on: {
              destroy: () => {
                self.closeCountryPopup();
              }
            }
          }
        );

        // set enable cookie
        Cookies.set(self.countryPopupCookieIdentifier, true, {
          expires: self.options.expiresInDays
        });
      }

      /**
       * Close country popup
       * @returns void
       */
      closeCountryPopup() {

        // Scope
        const self = this;

        Cookies.set(self.countryPopupCookieIdentifier, false, {
          expires: self.options.expiresInDays
        });

        Fancybox.close();
      }
    }

    window.CountryPopup = CountryPopup;
    customElements.define('country-popup', CountryPopup);
  }
})();
